var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择样式")
    }
  }, [_c("div", {
    staticClass: "imgList"
  }, _vm._l(_vm.configureList, function (item, index) {
    return _c("div", {
      key: index,
      class: _vm.form.controlsComponentsMark == item.mark ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.imgClick(item.mark, item.id);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.icon
      }
    })]);
  }), 0)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("参数字段")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.fieldColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.fieldColor, "fieldColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体增大")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.fieldFontSize,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fieldFontSize", $$v);
      },
      expression: "form.fieldFontSize"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 14
    }
  }, [_vm._v(" 14px ")]), _c("a-select-option", {
    attrs: {
      value: 18
    }
  }, [_vm._v(" 18px ")])], 1)], 1)])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("参数值")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.keyColor,
    on: {
      change: _vm.changeFun
    }
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.keyColor, "keyColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体增大")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.keyFontSize,
      callback: function ($$v) {
        _vm.$set(_vm.form, "keyFontSize", $$v);
      },
      expression: "form.keyFontSize"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 14
    }
  }, [_vm._v(" 14px ")]), _c("a-select-option", {
    attrs: {
      value: 16
    }
  }, [_vm._v(" 16px ")])], 1)], 1)])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他设置")
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.isHiddenClause
    },
    on: {
      change: _vm.changeClausFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("隐藏条款文件")) + " ")])], 1)], 1), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };